// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeName_container__QEWvw {
  width: 450px;
  height: 450px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;

  position: absolute;
  top: 92px;
  right: 5px;

  padding: 25px 40px 75px;

  box-shadow: 0px 3px 6px var(--color-theme-gray);
  border: 1px solid var(--color-theme-cloud);

  box-sizing: border-box;
}

/* p {
  font-size: 22px;
  margin: 0 !important;
} */

.ChangeName_button_container__NkWu8 {
  margin-top: 20px;
  justify-content: space-between;
  width: 370px;
  display: flex;
}

.ChangeName_btn_cancel__VsJVL {
  font-weight: bold !important;
  border: 1px solid var(--color-theme-silver) !important;
  color: var(--color-theme-silver);
}

.ChangeName_btn_confirm__mSkQp {
  font-weight: bold !important;
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
}

.ChangeName_changeNameHeader__cyb2d {
  font-size: 22px !important;
  height: 30px;
  color: var(--color-font-2);
  font-weight: bold;
  text-transform: uppercase;
}

.ChangeName_email__VPkWp {
  font-size: 16px !important;
  color: var(--color-font-2);
}

.ChangeName_succsse_message__1e1O5 {
  width: 100%;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  position: absolute;
  bottom: -1px;
  right: 0px;

  color: var(--color-theme-white);
  font-size: 16px;
  background: var(--color-theme-green);
}

.ChangeName_error_message__QoE61 {
  width: 100%;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: space-evenly;

  position: absolute;
  bottom: -1px;
  right: 0px;

  color: var(--color-theme-white);
  font-size: 16px;
  background: var(--color-theme-red);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/ChangeName/ChangeName.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;;EAE7B,kBAAkB;EAClB,SAAS;EACT,UAAU;;EAEV,uBAAuB;;EAEvB,+CAA+C;EAC/C,0CAA0C;;EAE1C,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,sDAAsD;EACtD,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;;EAE7B,kBAAkB;EAClB,YAAY;EACZ,UAAU;;EAEV,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;;EAE7B,kBAAkB;EAClB,YAAY;EACZ,UAAU;;EAEV,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC","sourcesContent":[".container {\n  width: 450px;\n  height: 450px;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-evenly;\n\n  position: absolute;\n  top: 92px;\n  right: 5px;\n\n  padding: 25px 40px 75px;\n\n  box-shadow: 0px 3px 6px var(--color-theme-gray);\n  border: 1px solid var(--color-theme-cloud);\n\n  box-sizing: border-box;\n}\n\n/* p {\n  font-size: 22px;\n  margin: 0 !important;\n} */\n\n.button_container {\n  margin-top: 20px;\n  justify-content: space-between;\n  width: 370px;\n  display: flex;\n}\n\n.btn_cancel {\n  font-weight: bold !important;\n  border: 1px solid var(--color-theme-silver) !important;\n  color: var(--color-theme-silver);\n}\n\n.btn_confirm {\n  font-weight: bold !important;\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n}\n\n.changeNameHeader {\n  font-size: 22px !important;\n  height: 30px;\n  color: var(--color-font-2);\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.email {\n  font-size: 16px !important;\n  color: var(--color-font-2);\n}\n\n.succsse_message {\n  width: 100%;\n  height: 55px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n\n  position: absolute;\n  bottom: -1px;\n  right: 0px;\n\n  color: var(--color-theme-white);\n  font-size: 16px;\n  background: var(--color-theme-green);\n}\n\n.error_message {\n  width: 100%;\n  height: 55px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n\n  position: absolute;\n  bottom: -1px;\n  right: 0px;\n\n  color: var(--color-theme-white);\n  font-size: 16px;\n  background: var(--color-theme-red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChangeName_container__QEWvw`,
	"button_container": `ChangeName_button_container__NkWu8`,
	"btn_cancel": `ChangeName_btn_cancel__VsJVL`,
	"btn_confirm": `ChangeName_btn_confirm__mSkQp`,
	"changeNameHeader": `ChangeName_changeNameHeader__cyb2d`,
	"email": `ChangeName_email__VPkWp`,
	"succsse_message": `ChangeName_succsse_message__1e1O5`,
	"error_message": `ChangeName_error_message__QoE61`
};
export default ___CSS_LOADER_EXPORT___;
